class ProductPagePriceUpdater {
  constructor() {}

  static calculateDiscountedPrice(price, quantity) {
    const discountPercentage = percentageByQuantity(quantity).discountPercentage;
    const discountedPrice = price * (discountPercentage / 100);

    return discountedPrice;
  }

  static calculateProductDiscount(variant, quantity) {
    const price = variant.price * quantity;
    const comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : 0;

    return { price: price, comparePrice: comparePrice };
  }

  static calculateStickerDiscount(variant, quantity) {
    const price = variant.price * quantity;
    const comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : 0;

    return { price: price, comparePrice: comparePrice };
  }

  static getCurrentQuantity(that) {
    const productFormLastInput = that.productForm.quantityInputs[that.productForm.quantityInputs.length - 1];
    return parseInt(productFormLastInput.value);
  }

  calculateDiscountedCompareAtPrice(compareAtPrice, quantity) {
    const discountPercentage = percentageByQuantity(quantity).discountPercentage;
    const discountedCompareAtPrice = compareAtPrice * (discountPercentage / 100);

    return discountedCompareAtPrice;
  }
}
